import React from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentSuccessPopup = ({ isVisible, onClose, planDetails }) => {
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    const redirectURL = window.sessionStorage.getItem('redirectUrlAfterTokensPurchase');
    window.sessionStorage.removeItem('redirectUrlAfterTokensPurchase');
    
    if (redirectURL) {
      navigate(redirectURL);
    } else {
      navigate('/dashboard');
    }
    onClose();
  };

  const handleContinueShopping = () => {
    onClose();
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4 text-center">
        {/* Success Icon */}
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>

        {/* Success Message */}
        <h2 className="text-2xl font-bold text-gray-900 mb-1">Payment Successful,</h2>
        <p className="text-gray-900 font-semibold text-lg mb-1">Thank you! Your Mock Interview is now active.</p>
        <p className="text-gray-600 mb-4">Take it anytime and get instant feedback that helps you improve fast.</p>

        {/* Share CTA — styled with same "impulse"/action-breathe styling as Action Items */}
        <div className="flex items-center justify-center mb-4">
          <div className="group flex items-center gap-3">
            {/* <span className="w-3 h-3 rounded-full bg-gray-300 transition-colors duration-200 group-hover:bg-[#FF5D0E] action-breathe"></span> */}
            <button
              type="button"
              // onClick={() => handleShare()}
              onClick={navigate('/mock')}
              className=" px-1 py-1 transition transform duration-200 ease-in-out rounded-md cursor-pointer hover:scale-[1.02] hover:bg-gray-100 active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-[#FF5D0E]"
            >
              Help a friend prepare too by — <span className="font-semibold">Sharing this AI Mock Interview</span>
            </button>
          </div>
        </div>

        {/* Plan Details */}
        {planDetails && (
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-600">Plan: <span className="font-semibold">{planDetails.planName}</span></p>
            <p className="text-sm text-gray-600">Amount: <span className="font-semibold">₹{planDetails.amount}</span></p>
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex gap-3">
          <button
            onClick={handleGoToDashboard}
            className="flex-1 bg-primary-color-900 text-white py-3 px-4 rounded-xl font-medium hover:bg-primary-color-800 transition-colors"
          >
            Go to Dashboard
          </button>
          <button
            onClick={handleContinueShopping}
            className="flex-1 bg-gray-200 text-gray-700 py-3 px-4 rounded-xl font-medium hover:bg-gray-300 transition-colors"
          >
            Continue Shopping
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPopup;
